import React, { useState } from 'react';
import { Button, Box, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signInWithGoogle } from '../services/googleAuth';
import { googleLogin } from '../store/slices/AuthSlice';
import { setUser } from '../store/slices/User';

interface GoogleSignInButtonProps {
  fullWidth?: boolean;
  variant?: 'contained' | 'outlined' | 'text';
  disabled?: boolean;
  onSuccess?: (idToken: string) => void;
  onError?: (error: string) => void;
}

const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  fullWidth = true,
  variant = 'outlined',
  disabled = false,
  onSuccess,
  onError
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    setLoading(true);
    try {
      const response = await signInWithGoogle();
      const { user, idToken } = response;
      console.log('user----',response);
      
      // Dispatch to Redux store
      // dispatch(googleLogin({ user, idToken: idToken || '' }));
      
      // Set user data in Redux store
      const userData = {
        id: user.uid,
        email: user.email,
        username: user.displayName || user.email?.split('@')[0],
        firstName: user.displayName?.split(' ')[0] || '',
        lastName: user.displayName?.split(' ')[1] || '',
        photoURL: user.photoURL,
        emailVerified: user.emailVerified,
        isGoogleUser: true
      };
      
      dispatch(setUser(userData));
      
      // Call success callback
      if (onSuccess) {
        onSuccess(idToken || '');
      } else {
        navigate('/');
      }
    } catch (error: any) {
      console.error('Google sign-in failed:', error);
      if (onError) {
        onError(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      fullWidth={fullWidth}
      variant={variant}
      onClick={handleGoogleSignIn}
      disabled={disabled || loading}
      sx={{
        textTransform: 'none',
        borderColor: '#F57C00',
        color: '#3c4043',
        backgroundColor: '#FFF3E0',
        '&:hover': {
          backgroundColor: '#f8f9fa',
          borderColor: '#dadce0',
        },
        height: '40px',
        fontSize: '14px',
        fontWeight: 500,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" sx={{ color: '#1D1B20' }}>
          {loading ? 'Signing in...' : 'Continue with Google'}
        </Typography>
      </Box>
    </Button>
  );
};

export default GoogleSignInButton; 